/**
 * PID 参数相关类型定义
 * 包含 PID 环标识、参数结构、历史记录、预设和阶跃响应指标
 */

/** PID 控制环标识 */
export type PidLoop = 'id' | 'iq' | 'speed' | 'position';

/** PID 控制器参数 */
export interface PidParameters {
  kp: number;              // 比例系数
  ki: number;              // 积分系数
  kd: number;              // 微分系数
  integralLimit: number;   // 积分限幅
  outputLimit: number;     // 输出限幅
  deadband: number;        // 死区
  filterCoeff: number;     // 滤波系数 (0-1, 1=无滤波)
}

/** PID 参数修改历史条目 */
export interface PidHistoryEntry {
  id: number;
  kp: number;
  ki: number;
  kd: number;
  integralLimit: number;
  outputLimit: number;
  deadband: number;
  filterCoeff: number;
  changedAt: number;
  changedBy: string;
}

/** PID 参数预设 */
export interface PidPreset {
  id: string;
  name: string;
  description?: string;
  loop: PidLoop;
  params: PidParameters;
  createdAt: number;
}

/** 阶跃响应性能指标 */
export interface StepResponseMetrics {
  riseTime: number;         // 上升时间 (s)
  overshoot: number;        // 超调量 (%)
  settlingTime: number;     // 调节时间 (s)
  steadyStateError: number; // 稳态误差
  decayRatio: number;       // 衰减比
  itae: number;             // ITAE 指标
}

/** 所有 PID 环标识数组 */
export const PID_LOOPS: PidLoop[] = ['id', 'iq', 'speed', 'position'];

/** PID 环中文标签 */
export const PID_LOOP_LABELS: Record<PidLoop, string> = {
  id: 'd轴电流环',
  iq: 'q轴电流环',
  speed: '速度环',
  position: '位置环',
};

/** 各 PID 环默认参数 */
export const DEFAULT_PID_PARAMS: Record<PidLoop, PidParameters> = {
  id:      { kp: 0.5,  ki: 100, kd: 0,    integralLimit: 12, outputLimit: 12, deadband: 0,    filterCoeff: 1   },
  iq:      { kp: 0.5,  ki: 100, kd: 0,    integralLimit: 12, outputLimit: 12, deadband: 0,    filterCoeff: 1   },
  speed:   { kp: 0.01, ki: 0.1, kd: 0,    integralLimit: 5,  outputLimit: 5,  deadband: 0,    filterCoeff: 0.5 },
  position:{ kp: 10,   ki: 0,   kd: 0.5,  integralLimit: 0,  outputLimit: 5,  deadband: 0.001, filterCoeff: 0.8 },
};
